import { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { Center, Spinner } from '@chakra-ui/react';
import { loadStripeFromEnv } from '../../../utils/loadStripeFromEnv';

const StripeElementsProvider = ({
  clientSecret,
  mode,
  amount,
  currency,
  paymentMethodTypes,
  appearance,
  locale = 'auto',
  children,
}) => {
  const [stripe, setStripe] = useState(null);

  useEffect(() => {
    const promise = loadStripeFromEnv();
    if (!promise) return undefined;
    let cancelled = false;
    promise.then((instance) => {
      if (!cancelled) setStripe(instance);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!stripe) {
    return (
      <Center data-testid="stripe-elements-loading" py={4}>
        <Spinner />
      </Center>
    );
  }

  const options = clientSecret
    ? { clientSecret, appearance, locale }
    : { mode, amount, currency, paymentMethodTypes, appearance, locale };

  return (
    <Elements stripe={stripe} options={options}>
      {children}
    </Elements>
  );
};

export default StripeElementsProvider;
